import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({
    initialize: function () {
      // get data url
      this.url = this.$el.attr('data-partialasync-url');
      this.html = null;

      this.afterSuccess = this.afterSuccess.bind(this);
      this.afterError = this.afterError.bind(this);

      this.render();
    },

    afterSuccess: function (res) {
      this.html = res || "";
      this.render();
    },

    afterError: function (res) {
      this.html = "Une erreur est survenue.";
    },

    fetch: function () {
      $.get(this.url).then(this.afterSuccess, this.afterError);
    },

    render: function () {
      if (this.html) {
        this.$el.html(this.html);
      } else if (this.html == "") {
        //
        $(".js-PartialAsync-spinner").hide();
      }
      else {
        this.fetch();

      }
      
    }
  });
